import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/images/fireicon.png'


const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "menu-buttons" }
const _hoisted_4 = {
  key: 0,
  class: "streak-container"
}
const _hoisted_5 = { class: "streak-wrapper" }
const _hoisted_6 = { class: "streak-count" }
const _hoisted_7 = { class: "streak-dropdown rounded-2xl" }
const _hoisted_8 = { class: "streak-info text-md text-[var(--highlight-color)] rounded-2xl" }
const _hoisted_9 = { class: "pr-8 pl-4 pt-4 pb-4 rounded-xl" }
const _hoisted_10 = { class: "pr-8 pl-4 pt-4 pb-4 rounded-xl" }

import { storeToRefs } from "pinia";
import { useUserStatsStore } from "@/store/userStatsStore";
import { useMenuStore } from "@/store/menuStore";
import { useAuthStore } from "@/store/authStore";
import { computed, onMounted } from "vue";
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const authStore = useAuthStore();
const loggedIn = computed(() => authStore.loggedIn);
const router = useRouter();

const userStats = useUserStatsStore();
const { currentStreak, bestStreak } = storeToRefs(userStats);

const menuStore = useMenuStore();

const pageTitle = computed(() => {
    return "rivue.ai";
});

const navigateToLogin = () => {
    if (router.currentRoute.value.path === '/login') {
        location.reload();
    } else {
        router.push('/login');
    }
};

const toggleSideMenu = (): void => {
    menuStore.toggleSideMenu();
};

onMounted(() => {
    if (loggedIn.value && userStats.streakLoaded == false) {
        userStats.fetchStreak();
    }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("div", {
          class: "app-title",
          onClick: navigate
        }, _toDisplayString(pageTitle.value), 9, _hoisted_2)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (loggedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                class: "logo",
                src: _imports_0,
                alt: "Fire Streak Icon",
                style: {"max-height":"24px","pointer-events":"none"}
              }, null, -1)),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(currentStreak)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, "Current Streak: " + _toDisplayString(_unref(currentStreak)), 1),
                _createElementVNode("p", _hoisted_10, "Best Streak: " + _toDisplayString(_unref(bestStreak)), 1),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "pr-8 pl-4 pt-4 pb-4 rounded-xl streak-desc" }, "Complete a lesson each day to keep your streak. Missing a day resets it.", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!loggedIn.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "login-button",
            onClick: navigateToLogin
          }, " Log in "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "menu-btn icon-btn",
        onClick: toggleSideMenu,
        "aria-label": "side menu"
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("span", { class: "menu-line" }, null, -1),
        _createElementVNode("span", { class: "menu-line" }, null, -1),
        _createElementVNode("span", { class: "menu-line" }, null, -1)
      ]))
    ])
  ]))
}
}

})